module.exports = __webpack_public_path__ + "media/images/gallery/12-cda049367d9327be34e0f0e3593bdaed.jpg";